module.exports = __webpack_public_path__ + "media/application/images/ui/endorsement_top-brand-0bb1a9a4dbea6627929f1fefb2310a96.png";